import { post, get } from "../httpmethods";
import { put } from "../httpmethods";
import { URL_API } from "../config";


export const OwnerAPI = {
    createOwner: async (body) => {
        return await post(`${URL_API}/owners`, body);
    },
    getOwners: async (data) => {
        return await get(`${URL_API}/owners`, data );
    },
    getOwnerById: async (id) => {
        return await get(`${URL_API}/owners/${id}`);
    },
    deleteOwner: async (id) => {
        return await post(`${URL_API}/owners/${id}`);
    },
    updateOwner: async (id, body) => {
        return await put(`${URL_API}/owners/${id}`, body);
    }
}